import React, { Fragment } from 'react';
import { DateFormatter } from 'components/charts/formatters';
import { useWidget } from 'components/Widget/useWidget';
import getFormattedNumber from 'store/redux/utils/getFormattedNumber';
import getFormattedValue from 'store/redux/utils/getFormattedValue';
import { integrationMetricList } from 'modules/DashboardModule/charts/components/IntegrationMetricList';

export const MetricItem = ({ entry, metricsList }) => {
  const metricDefinition = (metricsList || integrationMetricList)[entry.dataKey] || {};
  const { name, color, symbol, currency, valueFormatter, formatter } = metricDefinition;

  let formattedValue = entry.value;
  if (symbol) {
    formattedValue = `${getFormattedNumber(entry.value)}${symbol}`;
  } else if (currency) {
    formattedValue = getFormattedValue(entry.value);
  }

  const ValueFormatter = valueFormatter || Fragment;
  const FormatterComponent = formatter || Fragment;

  return (
    <div
      className='flex items-center w-full gap-6 justify-between !font-semibold'
      key={entry.dataKey}
    >
      <div className='flex items-center w-fit gap-1'>
        {color && (
          <div className='rounded-sm h-3 w-3' style={{ background: entry?.color || color }} />
        )}
        <span className='text-sm font-normal'>{name}</span>
      </div>
      <span className='!text-sm'>
        {valueFormatter ? (
          <ValueFormatter value={entry?.value} />
        ) : formatter ? (
          <FormatterComponent row={entry.payload} />
        ) : (
          formattedValue
        )}
      </span>
    </div>
  );
};

const CustomTooltip = ({ active, payload, label, metricsList, dataKey = 'date' }) => {
  const { filters } = useWidget();

  if (!active || !payload?.length) return null;

  const formattedDate = DateFormatter({ period: filters?.group_by || 'days', date: label });
  const gridColsClass = payload.length > 8 ? 'grid-cols-2' : 'grid-cols-1';

  return (
    <div
      className='p-2 rounded shadow-xl gap-2 grid'
      style={{ background: 'rgba(255,255,255,0.95' }}
    >
      <div className='font-semibold text-md'>{dataKey === 'date' ? formattedDate : label}</div>
      <div className={`grid w-full gap-x-4 gap-y-1 ${gridColsClass}`}>
        {payload.map((entry) => (
          <MetricItem key={entry.dataKey} entry={entry} metricsList={metricsList} />
        ))}
      </div>
    </div>
  );
};

export default CustomTooltip;
